<li (click)="this.buttonClick.emit(event())" role="button" tabindex="{{ event() }}">
  <orbit-fa-icon class="descriptive-icon" [iconName]="icon()" />
  <span class="descriptive-text">{{ text() }}</span>
</li>
